<template>
  <div class="flex">
    <div class="dropdown dropdown-bottom dropdown-start">
      <div tabindex="0" role="button" class="btn btn-link flex items-center gap-0">
        {{ selectedStage }}
        <vue-feather type="chevron-down" class="h-4 ml-1" />
      </div>
      <div
        tabindex="0"
        class="dropdown-content z-[1] card card-compact w-64 p-2 shadow-md border border-gray-200 bg-white text-primary-content"
      >
        <div class="card-body">
          <label class="form-control w-full max-w-xs">
            <div class="label mt-0 pt-0">
              <span class="label-text text-gray-600">Candidate Stage</span>
            </div>
            <select
              v-if="stageFilter"
              v-model="stageFilter.value"
              class="select select-bordered text-gray-800 focus:outline-none focus:border-gray-300 focus:ring-0"
              @change="$emit('update-filter', newFilters)"
            >
              <option value="All">All</option>
              <option value="Applied">Applied</option>
              <option value="Phone Screen">Phone Screen</option>
              <option value="Interview">Interview</option>
              <option value="Onboarding">Onboarding</option>
              <option value="Hired">Hired</option>
              <option value="Nurture">Nurture</option>
              <option value="Declined">Declined</option>
              <option value="Disqualified">Disqualified</option>
              <option value="Unlicensed">Unlicensed</option>
              <option value="Unlicensed with Coursework Started">Unlicensed with Coursework Started</option>
            </select>
          </label>
        </div>
      </div>
    </div>
    <div v-if="showLeadSource" class="dropdown dropdown-bottom dropdown-start">
      <div tabindex="0" role="button" class="btn btn-link flex items-center gap-0">
        {{ selectedLeadSource }}
        <vue-feather type="chevron-down" class="h-4 ml-1" />
      </div>
      <div
        tabindex="0"
        class="dropdown-content z-[1] card card-compact w-64 p-2 shadow-md border border-gray-200 bg-white text-primary-content"
      >
        <div class="card-body">
          <label class="form-control w-full max-w-xs">
            <div class="label mt-0 pt-0">
              <span class="label-text text-gray-600">Lead Source</span>
            </div>
            <select
              v-if="leadSourceFilter"
              v-model="leadSourceFilter.value"
              class="select select-bordered text-gray-800 focus:outline-none focus:border-gray-300 focus:ring-0"
              @change="$emit('update-filter', newFilters)"
            >
              <option value="all">All</option>
              <option value="indeed">Indeed</option>
              <option value="monster">Monster</option>
              <option value="zip_recruiter">ZipRecruiter</option>
              <option value="meta">Meta</option>
            </select>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      stageFilter: null,
      leadSourceFilter: null,
    };
  },
  computed: {
    showLeadSource() {
      return this.$store.state.general.currentUserAccountDetails?.featureFlags?.visible_lead_sources;
    },
    selectedStage() {
      if (!this.stageFilter || !this.stageFilter.value || this.stageFilter.value === 'All') {
        return 'All Stages';
      }
      return `Candidate Stage: ${this.stageFilter.value}`;
    },
    selectedLeadSource() {
      if (!this.leadSourceFilter || !this.leadSourceFilter.value || this.leadSourceFilter.value === 'all') {
        return 'All Lead Sources';
      }
      return `Lead Source: ${this.leadSourceFilter.value}`;
    },
    newFilters() {
      return {
        stage: this.stageFilter,
        lead_source: this.leadSourceFilter,
      };
    },
  },
  mounted() {
    this.stageFilter = { ...this.filters.find(f => f.key === 'stage') };
    this.leadSourceFilter = {
      ...this.filters.find(f => f.key === 'lead_source'),
    };
  },
};
</script>
